import SiafLiteApiRepository from "../../external/siafLiteApi";

class ConfiguracoesAgendaFuncionamentoService {
  constructor() {
    this.urlBase = "/estoque/configuracoes-agenda-funcionamento";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  find() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }

  upsert(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }
}

export default ConfiguracoesAgendaFuncionamentoService;
